import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      isUpdatingPromoCode: false, // Indicador para evitar ciclos
    };
  },
  computed: {
    ...mapGetters({
      isAutenticated: "user/user",
      userIsVIPMember: "user/userIsVIPMember",
      // Agrega otras propiedades computadas si es necesario...
    }),
  },
  watch: {
    isAutenticated: 'onUserStateChange',
    userIsVIPMember: 'onUserStateChange',
  },
  methods: {
    /**
     * Triggered when isAuthenticated or userIsVIPMember changes.
     * Prevents infinite loops using a flag.
     */
    async onUserStateChange(newValue, oldValue) {
      if (newValue !== oldValue && !this.isUpdatingPromoCode) {
        this.isUpdatingPromoCode = true;
        await this.activatePromoCode();
        this.isUpdatingPromoCode = false;
      }
    },

    /**
     * Initialize event listeners to activate promo code on interaction.
     */
    initLoadEvents(event) {
      this.activatePromoCode();
      event?.currentTarget?.removeEventListener(event.type, this.initLoadEvents);
    },

    /**
     * Activate promo code based on various conditions.
     * Dispatches the necessary Vuex action.
     */
    async activatePromoCode() {
      let body = {};

      if (this.user && this.user.isClient === true) {
        body.code = "groupdiscount";
      } else {
        body.code = "peppertixpromo";
      }

      const segments = this.$route.path.split("/");
      let route = segments.length >= 2 ? segments[1] : null;

      if (route === "checkout" && !this.user) {
        // body.code = 'no-code-to-apply'
      }

      if (
        this.activePromoCode &&
        this.activePromoCode.code &&
        this.activePromoCode.code != "peppertixpromo"
      ) {
        body.code = this.activePromoCode.code;
      }

      if (!this.user && this.activePromoCode?.code === "groupdiscount") {
        body.code = "peppertixpromo";
      }

      if (this.$route.query.promocode) {
        body.code = this.$route.query.promocode;
      }

      if (this.user && this.userIsVIPMember) {
        body.code = "superbowly20mscpfeffer";
      }


      console.log("body", body);

      // Despacha la acción al store
      await this.$store.dispatch("checkout/verifyPromoCode", body);
    },
  },

  mounted() {
    this.$nextTick(() => {
      console.log("path >> " + this.$route.path);
      if (this.$route.path.includes("/checkout")) {
        this.initLoadEvents();
        return;
      }
      document.addEventListener("mousemove", this.initLoadEvents);
      document.addEventListener("touchstart", this.initLoadEvents);
    });
  },
  destroyed() {
    // Limpieza de eventos para evitar fugas de memoria
    document.removeEventListener("mousemove", this.initLoadEvents);
    document.removeEventListener("touchstart", this.initLoadEvents);
  },
};
